import { withTranslation } from "react-i18next";
import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
      errorInfo: null
    };
  }

  static getDerivedStateFromError(error) {
    return {
      hasError: true,
      error
    };
  }

  componentDidCatch(error, errorInfo) {
    console.error("ErrorBoundary caught an error", error, errorInfo);
    this.setState({
      errorInfo
    });
  }

  render() {
    const { t } = this.props;
    if (this.state.hasError) {
      return <div style={{
        padding: '20px',
        backgroundColor: '#fee',
        color: '#a00',
        fontFamily: 'monospace'
      }}>
          <h2>{t("Something went wrong in the UI.")}</h2>
          <details style={{
          whiteSpace: 'pre-wrap'
        }}>
            <summary>{t("Click for error details")}</summary>
            <br />
            {this.state.error && this.state.error.toString()}
            <br />
            {this.state.errorInfo && this.state.errorInfo.componentStack}
          </details>
          <button style={{
          marginTop: '20px',
          padding: '10px'
        }} onClick={() => window.location.reload()}>{t("Reload Page")}</button>
        </div>;
    }

    return this.props.children;
  }

}

export default withTranslation()(ErrorBoundary);